import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Grid, Tab, TextField } from "@mui/material";
import type { FC } from "react";
import type { ParticipantListTemplateResponse } from "./participantListApi";
import type { UseParticipantListEditorResult } from "./useParticipantListEditor";
import ParticipantListCombination from "./ParticipantListCombination";
import type { ParticipantListResponse } from "./participantListApi";

interface Props {
  readonly template: ParticipantListTemplateResponse;
  readonly previousParticipantList: Omit<ParticipantListResponse, "id" | "createdAt"> | undefined;
  readonly editor: UseParticipantListEditorResult;
}

const ParticipantListEditForm: FC<Props> = ({ template, previousParticipantList, editor }) => {
  const {
    combinationIdx,
    setCombinationIdx,
    combinationsState,
    plateNumber,
    setPlateNumber,
    driverPhone,
    setDriverPhone,
    tourLeaderPhone,
    setTourLeaderPhone,
    handlePersonChange,
    handleCopyFromFirstCombination,
  } = editor;

  return (
    <>
      <Grid size={12} data-testid="new-participants-list">
        <TabContext value={combinationIdx}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList onChange={(_, newValue) => setCombinationIdx(newValue)} aria-label="Kombinacje listy osób">
              {template.combinations.map((_, idx) => (
                <Tab key={idx} label={`Układ ${idx + 1}`} value={`${idx}`} />
              ))}
            </TabList>
          </Box>
          {template.combinations.map((c, idx) => (
            <TabPanel value={`${idx}`} key={idx} sx={{ minHeight: "400 px" }}>
              {combinationIdx === `${idx}` && (
                <ParticipantListCombination
                  combination={c}
                  requiredFields={template.requiredFields}
                  participants={combinationsState[idx] ?? {}}
                  previousParticipants={previousParticipantList ? previousParticipantList.combinations[idx] : undefined}
                  onParticipantsChange={(roomType, roomIdx, personIdx, p) =>
                    handlePersonChange(idx, roomType, roomIdx, personIdx, p)
                  }
                  onCopyFromFirstCombination={idx !== 0 ? () => handleCopyFromFirstCombination(idx) : undefined}
                />
              )}
            </TabPanel>
          ))}
        </TabContext>
      </Grid>
      <Grid size={12}>
        <TextField
          type="phone"
          label="Tour leader phone"
          value={tourLeaderPhone}
          sx={{ minWidth: "300px" }}
          onChange={(e) => setTourLeaderPhone(e.target.value)}
        />
      </Grid>
      {template.isBusRequired && (
        <Grid container size={12} spacing={2}>
          <TextField
            label="Bus plate number"
            value={plateNumber}
            sx={{ minWidth: "300px" }}
            onChange={(e) => setPlateNumber(e.target.value)}
          />
          <TextField
            label="Driver phone"
            type="phone"
            value={driverPhone}
            sx={{ minWidth: "300px" }}
            onChange={(e) => setDriverPhone(e.target.value)}
          />
        </Grid>
      )}
    </>
  );
};

export default ParticipantListEditForm;
